import { render, staticRenderFns } from "./Category2.vue?vue&type=template&id=4e989064&scoped=true"
import script from "./Category2.vue?vue&type=script&lang=js"
export * from "./Category2.vue?vue&type=script&lang=js"
import style0 from "./Category2.vue?vue&type=style&index=0&id=4e989064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e989064",
  null
  
)

export default component.exports